import axios from 'axios'
import swal from 'sweetalert'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

const defaultState = {
  name: "",
  tags: [],
  text: "",
  documents: []
}

export default function manageResourcePostCreation(state = defaultState, action) {
  switch (action.type) {
    case "CHANGE_NAME":
      return {...state, name: action.payload}
    case "CHANGE_TAGS":
      return {...state, tags: action.payload}
    case "CHANGE_TEXT":
      return {...state, text: action.payload}
    case "ADD_DOCUMENTS":
      return {...state, documents: [...state.documents, ...action.payload]}
    case "REMOVE_DOCUMENT":
      return {...state, documents: [...state.documents.slice(0, action.payload), ...state.documents.slice(action.payload + 1)]}
    case "CANCEL_CREATION":
    return defaultState
    default:
      return state
  }
}



export const changeName = (name) => {
  return { type: "CHANGE_NAME", payload: name }
}

export const changeTags = (tags) => {
  return { type: "CHANGE_TAGS", payload: tags }
}

export const changeText = (text) => {
  return { type: "CHANGE_TEXT", payload: text }
}

export const changeDocuments = (documents) => {
  return { type: "ADD_DOCUMENTS", payload: documents }
}

export const removeDocument = (index) => {
  return { type: "REMOVE_DOCUMENT", payload: index }
}

export const cancelCreation = () => {
  return { type: "CANCEL_CREATION" }
}

export const submitPost = (post, history) => {
  return (dispatch) => {
    axios({
      method: "POST",
      url: `${getServerURL()}resource-posts/resource-posts/`,
      headers: {
          "Authorization": "Bearer " + localStorage.getItem("token"),
          'Content-Type': 'multipart/form-data'
        },
      data: post
    })
    .then(response => {
      swal({
        title: "Success!",
        text: "The post has been posted!",
        icon: "success",
        button: "Continue!",
      })
      history.push(`/resource-posts/`)
      dispatch(cancelCreation())
    })
    .catch(error => {
      const message = "There was an error creating your resource post."
      handleErrorFetchingData(error, message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/resource-posts_new/reducers/manageResourcePostCreation.js